import { NgTemplateOutlet } from '@angular/common';
import type { SimpleChanges, TemplateRef } from '@angular/core';
import { ChangeDetectorRef, Component, ElementRef, Input, output, inject } from '@angular/core';

import type { User } from '@core/account-types';
import { trackByProp } from '@core/common-legacy';
import { I18nService } from '@core/i18n-legacy';
import {
  AvatarComponent,
  ButtonLoadingDirective,
  HeadingComponent,
  IconButtonComponent,
  IconComponent,
  RtTooltip,
} from '@core/user-interface-legacy';
import type { RoleWithAdmins } from '@core/visibility-legacy';

@Component({
  selector: 'rt-team-members-item',
  templateUrl: 'team-members-item.component.html',
  styleUrls: ['./team-members-item.component.less'],
  imports: [
    AvatarComponent,
    ButtonLoadingDirective,
    HeadingComponent,
    IconButtonComponent,
    IconComponent,
    RtTooltip,
    NgTemplateOutlet,
  ],
  host: {
    '[class.is-last]': 'isLast',
  },
})
export class TeamMembersItemComponent {
  private readonly i18n = inject(I18nService);

  protected readonly cdRef = inject(ChangeDetectorRef);

  public readonly elRef = inject(ElementRef);

  @Input() public removable: boolean = false;
  @Input() public collapsable: boolean = false;
  @Input() public isSimple: boolean = false;
  @Input() public isLast: boolean = false;
  @Input() public admin: User | null = null;
  @Input() public roleWithAdmins: RoleWithAdmins | null = null;
  @Input() public adminInRemove: number | null = null;
  @Input() public hasPadding: boolean = false;
  @Input() public hasManageSettingsButton: boolean = false;
  @Input() public hasNoBorderBottom: boolean = false;
  @Input() public hasCheckboxOffset: boolean = false;
  @Input() public roleDescription: string = '';
  @Input() public isDisabled: boolean = false;
  @Input() public removeTooltipText: string = this.i18n.translate(
    'app.offer_assignments.remove_recruiter',
  );
  @Input() public headingSlotTemplate: TemplateRef<any> | null = null;

  public removeFollower = output<User>();
  public goToManageRole = output<number>();
  public itemExpanded = output<void>();

  public trackById = trackByProp<{ id: number }>({ prop: 'id' });
  public expanded: boolean = false;

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.roleWithAdmins && changes.roleWithAdmins.currentValue) {
      this.expanded = changes.roleWithAdmins.currentValue.expanded;
      this.cdRef.detectChanges();
    }
  }

  public toggleList(): void {
    this.expanded = !this.expanded;
    this.cdRef.detectChanges();
    if (this.expanded) this.itemExpanded.emit();
  }

  public trackByIndex(index: number, _: any): number {
    return index;
  }
}
